export default "__VITE_ASSET__Qs1qireJ__"